module.exports = __webpack_public_path__ + "media/images/bet__bg--dhi-ac53ffdaebee23b53635cdb5a27ef7e0.jpg";